import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

const PrivacyPolicy: React.FC = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();

    return (
        <div className="container mx-auto py-8 px-4 max-w-4xl">
            <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-2 text-gray-600 dark:text-gray-400 hover:text-blue-500 dark:hover:text-blue-400 transition-colors mb-6"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
                {language === 'tr' ? 'Geri Dön' : 'Go Back'}
            </button>

            <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 shadow-xl border border-gray-200 dark:border-gray-700">
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-6">
                    {language === 'tr' ? 'Gizlilik Politikası' : 'Privacy Policy'}
                </h1>

                <p className="text-gray-600 dark:text-gray-400 mb-6">
                    {language === 'tr'
                        ? 'Son güncelleme: 19 Ocak 2026'
                        : 'Last updated: January 19, 2026'}
                </p>

                <div className="prose dark:prose-invert max-w-none space-y-6 text-gray-700 dark:text-gray-300">
                    {language === 'tr' ? (
                        <>
                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">1. Giriş</h2>
                                <p>
                                    ServeRS olarak kişisel verilerinizin korunmasına büyük önem veriyoruz. Bu Gizlilik Politikası,
                                    web sitemizi ve hizmetlerimizi kullandığınızda hangi bilgilerin toplandığını, nasıl kullanıldığını
                                    ve korunduğunu açıklamaktadır.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">2. Toplanan Bilgiler</h2>
                                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2">2.1 Hesap Bilgileri</h3>
                                <ul className="list-disc pl-6 space-y-1">
                                    <li>E-posta adresi</li>
                                    <li>Kullanıcı adı</li>
                                    <li>Profil resmi (isteğe bağlı)</li>
                                    <li>OAuth sağlayıcısından gelen temel profil bilgileri (Google ile giriş yapıldığında)</li>
                                </ul>

                                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2 mt-4">2.2 Kullanım Verileri</h3>
                                <ul className="list-disc pl-6 space-y-1">
                                    <li>Ziyaret edilen sayfalar</li>
                                    <li>Sunucu incelemeleri ve puanlamaları</li>
                                    <li>Favori sunucular</li>
                                    <li>Oturum bilgileri ve giriş zamanları</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">3. Bilgilerin Kullanımı</h2>
                                <p>Topladığımız bilgileri şu amaçlarla kullanıyoruz:</p>
                                <ul className="list-disc pl-6 space-y-1 mt-2">
                                    <li>Hesabınızı oluşturmak ve yönetmek</li>
                                    <li>Hizmetlerimizi sağlamak ve geliştirmek</li>
                                    <li>İnceleme ve puan sistemini işletmek</li>
                                    <li>Teknik destek sağlamak</li>
                                    <li>Platform güvenliğini sağlamak</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">4. Bilgi Paylaşımı</h2>
                                <p>
                                    Kişisel bilgilerinizi üçüncü taraflarla satmıyoruz. Bilgileriniz yalnızca şu durumlarda paylaşılabilir:
                                </p>
                                <ul className="list-disc pl-6 space-y-1 mt-2">
                                    <li>Yasal zorunluluklar gerektirdiğinde</li>
                                    <li>Hizmet sağlayıcılarımızla (Supabase, Firebase) teknik gereklilikler için</li>
                                    <li>Açık onayınız olduğunda</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">5. Çerezler</h2>
                                <p>
                                    Web sitemiz, oturum yönetimi ve tercihlerinizi hatırlamak için çerezler kullanır.
                                    Tarayıcı ayarlarınızdan çerezleri devre dışı bırakabilirsiniz, ancak bu bazı özelliklerin
                                    çalışmamasına neden olabilir.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">6. Veri Güvenliği</h2>
                                <p>
                                    Verilerinizi korumak için endüstri standardı güvenlik önlemleri kullanıyoruz:
                                </p>
                                <ul className="list-disc pl-6 space-y-1 mt-2">
                                    <li>HTTPS şifreleme</li>
                                    <li>Güvenli kimlik doğrulama sistemleri</li>
                                    <li>Düzenli güvenlik güncellemeleri</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">7. Haklarınız</h2>
                                <p>KVKK kapsamında aşağıdaki haklara sahipsiniz:</p>
                                <ul className="list-disc pl-6 space-y-1 mt-2">
                                    <li>Verilerinize erişim talep etme</li>
                                    <li>Verilerinizin düzeltilmesini isteme</li>
                                    <li>Verilerinizin silinmesini talep etme</li>
                                    <li>Veri işlemeye itiraz etme</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">8. İletişim</h2>
                                <p>
                                    Gizlilik politikamız hakkında sorularınız için Discord sunucumuza katılabilir veya
                                    bize e-posta gönderebilirsiniz.
                                </p>
                            </section>
                        </>
                    ) : (
                        <>
                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">1. Introduction</h2>
                                <p>
                                    At ServeRS, we take the protection of your personal data seriously. This Privacy Policy
                                    explains what information is collected when you use our website and services, how it is used,
                                    and how it is protected.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">2. Information We Collect</h2>
                                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2">2.1 Account Information</h3>
                                <ul className="list-disc pl-6 space-y-1">
                                    <li>Email address</li>
                                    <li>Username</li>
                                    <li>Profile picture (optional)</li>
                                    <li>Basic profile information from OAuth providers (when signing in with Google)</li>
                                </ul>

                                <h3 className="text-lg font-medium text-gray-800 dark:text-gray-200 mb-2 mt-4">2.2 Usage Data</h3>
                                <ul className="list-disc pl-6 space-y-1">
                                    <li>Pages visited</li>
                                    <li>Server reviews and ratings</li>
                                    <li>Favorite servers</li>
                                    <li>Session information and login times</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">3. How We Use Information</h2>
                                <p>We use the information we collect to:</p>
                                <ul className="list-disc pl-6 space-y-1 mt-2">
                                    <li>Create and manage your account</li>
                                    <li>Provide and improve our services</li>
                                    <li>Operate the review and rating system</li>
                                    <li>Provide technical support</li>
                                    <li>Ensure platform security</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">4. Information Sharing</h2>
                                <p>
                                    We do not sell your personal information to third parties. Your information may only be shared in the following cases:
                                </p>
                                <ul className="list-disc pl-6 space-y-1 mt-2">
                                    <li>When required by law</li>
                                    <li>With our service providers (Supabase, Firebase) for technical requirements</li>
                                    <li>With your explicit consent</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">5. Cookies</h2>
                                <p>
                                    Our website uses cookies for session management and to remember your preferences.
                                    You can disable cookies in your browser settings, but this may cause some features to not work properly.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">6. Data Security</h2>
                                <p>We use industry-standard security measures to protect your data:</p>
                                <ul className="list-disc pl-6 space-y-1 mt-2">
                                    <li>HTTPS encryption</li>
                                    <li>Secure authentication systems</li>
                                    <li>Regular security updates</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">7. Your Rights</h2>
                                <p>Under GDPR and similar regulations, you have the right to:</p>
                                <ul className="list-disc pl-6 space-y-1 mt-2">
                                    <li>Request access to your data</li>
                                    <li>Request correction of your data</li>
                                    <li>Request deletion of your data</li>
                                    <li>Object to data processing</li>
                                </ul>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-3">8. Contact</h2>
                                <p>
                                    For questions about our privacy policy, you can join our Discord server or send us an email.
                                </p>
                            </section>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
